export default __webpack_public_path__ + "static/media/cowboy_egg.eaa1721f.png";